import React from 'react';
import useCategoryProduct from '../useCategoryProduct';
import useFilter from '../useFilter';
import useAuth from '../useAuth';
import useSort from '../useSort';
const ShopContext = React.createContext();

export const ShopProvider = ({ children }) => {


  const {
    catProd,
    getProductsByCategory,
    setProductResultsPagesTotal,
    catProdLoading,
    setCatProdLoading,
    queryProductsApi,
    getCategories,
    initializeResults,
    getSecondaryProducts
  } = useCategoryProduct()

  const {auth} = useAuth();

  const {
    filters,
    selectedFilters,
    filterCounts,
    addRemoveSelectedFilter,
    resetSelectedFilters,
    

  } = useFilter();

  const {
    sort, handleChangeSort,
  } = useSort();

  return (
    <ShopContext.Provider value={{

      //  from useCategoryProduct   
      catProd,
      getProductsByCategory,
      setProductResultsPagesTotal,
      catProdLoading,
      setCatProdLoading,
      queryProductsApi,
      getCategories,
      initializeResults,
      getSecondaryProducts,

      // from useFilter
      filters,
      selectedFilters,
      filterCounts,
      addRemoveSelectedFilter,
      resetSelectedFilters,

      // from useAuth
      auth,

      // from useSort
      sort, handleChangeSort,

    }}>
      {children}
    </ShopContext.Provider>
  )
}
export default ShopContext;